class ContactOption {
    constructor(contactOption) {
        const button = contactOption.querySelector('.contact-option__button') || document.createElement('button');
        const expandableArea = contactOption.querySelector('.contact-option__expandable');

        expandableArea.dataset.height = expandableArea.offsetHeight;
        expandableArea.style.height = '0px';

        button.addEventListener('click', (e) => {
            const buttonTextElement = button.querySelector('span');
            const isExpanded = contactOption.classList.contains('contact-option--expanded');
            button.setAttribute("aria-expanded", !isExpanded);

            if (isExpanded) {
                expandableArea.style.height = '0px';
                buttonTextElement.innerText = button.dataset.open;
                contactOption.classList.remove('contact-option--expanded');
            } else {
                expandableArea.style.height = `${Number(expandableArea.dataset.height) + 32}px`;
                buttonTextElement.innerText = button.dataset.close;
                contactOption.classList.add('contact-option--expanded');
            }

        });

        contactOption.classList.remove('contact-option--loading');
        contactOption.classList.remove('contact-option--expanded');
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const expandableContactOptions = [...document.querySelectorAll('.contact-option.contact-option--expandable')];

    if (expandableContactOptions) {
        expandableContactOptions.forEach((contactOption) => {
            new ContactOption(contactOption);
        });
    }

    // Set equal min-height
    const allContactOptions = [...document.querySelectorAll('.contact-option')]
    const minHeight = allContactOptions.reduce((max, element) => {
        return Math.max(max, element.clientHeight);
    }, 0);

    allContactOptions.forEach((el) => {
        el.style.minHeight = `${(minHeight - 4)}px`;
        const container = el.querySelector('.contact-option__container');

        container.style.minHeight = `${(minHeight - 4)}px`;
    });
});